import React, { Component, useState, useRef, Fragment } from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Modal, Button, message, Select, Input, InputNumber } from 'antd'
import styles from './changeBalanceDialog.module.scss'

const formItemLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 15 },
}

@Form.create()
class ChangeBalanceForm extends Component {
  state = {
    loading: false,
  }

  handleSubmit = e => {
    const { onSubmit, submit } = this.props
    e.preventDefault()

    this.props.form.validateFields((err, values) => {
      if (err) {
        Object.entries(err).forEach(([_, { errors }]) => {
          errors.forEach(({ message: msg }) => {
            message.error(msg)
          })
        })

        return console.error(err)
      }

      onSubmit(values)
      submit()
    });
  }

  render() {
    const { typeList = [] } = this.props
    const { getFieldDecorator, validateFields, getFieldValue } = this.props.form

    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <Form.Item
            {...formItemLayout}
            label="拒绝理由"
            required>
            {getFieldDecorator('reject_reason', {
              rules: [
                {
                  required: true,
                  message: '请输入拒绝理由',
                },
              ],
            })(
              <Input.TextArea autoFocus rows={3} placeholder="输入拒绝理由" />
            )}
          </Form.Item>
          <div className={styles.footer}>
            <Button type="primary" htmlType="submit">提交</Button>
          </div>
        </Form>
      </div>
    )
  }
}

const ChangeBalance = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={500}
    centered
    visible={isOpen}
    onCancel={hide}>
    <ChangeBalanceForm submit={submit} {...ownProps} />
  </Modal>
)

export default sagaModal({
  name: 'REJECT_JOIN_REQUEST_DIALOG',
 })(ChangeBalance)
